/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DnDProviderAPI
 * @hideconstructor
 * @classdesc API class that handles drag and drop of metadata to create a visualization.
 */

define([], () => {
	return class DnDProviderAPI {

		/**
		 * @public
		 * @function DnDProviderAPI#accepts
		 * @param {Object} payload the drag and drop payload
		 * @description called by the DnD manager to check whether to accept the dragged object or not
		 * @returns {Boolean}
		 */
		accepts() {}

		/**
		 * @public
		 * @function DnDProviderAPI#onDrop
		 * @param {Object} payload the drag and drop payload
		 * @param {Object} targetNode the DOM target node to accept the drop
		 * @param {Object} event the jQuery event object
		 * @description process the on drop action of drag and drop
		 */
		onDrop () {}
	};
});
